import Footer from '@/app/components/Footer/Footer';
import Header from '@/app/components/Header/Header';
import { SupportDonioBanner } from '@/app/components/SupportDonioBanner/SupportDonioBanner';
import { countryConfig } from '@/app/utils/countryConfig';
import { PropsWithChildren } from 'react';

interface LayoutWithFooterProps {
  children: React.ReactNode;
  params: Promise<{ lng: string }>;
}

export const FullPageLayout = ({ children }: PropsWithChildren) => {
  return (
    <main id="main-gradient" className="background-gradient">
      {countryConfig.isSupportDonioBannerVisible && <SupportDonioBanner />}
      <Header className={countryConfig.isSupportDonioBannerVisible ? 'header-with-top-offset' : ''} />
      {children}
      <Footer />
    </main>
  );
};

const PagesLayout = async ({ children }: LayoutWithFooterProps) => {
  return <FullPageLayout>{children}</FullPageLayout>;
};

export default PagesLayout;
